"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.i18nLocizeInstance = exports.default = void 0;

var _utils = require("./utils");

var _i18next = _interopRequireDefault(require("i18next"));

var _i18nextLocizeBackend = _interopRequireDefault(require("i18next-locize-backend"));

var _locizeEditor = _interopRequireDefault(require("locize-editor"));

var _languagePrefix = _interopRequireDefault(require("./language-prefix"));

var _reactI18next = require("react-i18next");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: Allow subdomains
// This would require pull request in i18next-locize-backend too
// https://github.com/locize/i18next-locize-backend
// because now it allows only exact domains for allowedAddOrUpdateHosts option
var DEBUG_HOSTS = ['localhost', 'app.hub.infl.dev', 'qalocize.influitiveqa.com'];
var DEBUG_MODE = DEBUG_HOSTS.indexOf(window.location.hostname) > -1;
var REFERENCE_LANG = 'en';
var CACHABLE_VERSION = 'stable';
var DEV_VERSION = 'latest';
/* eslint-disable complexity */

var initOptions = function initOptions(locizeProjectId, locizeApiKey, options) {
  var hubLang = window._infl && window._infl.hub && window._infl.hub.lang;
  var queryLang = (0, _utils.getQueryVariable)('lang');
  var defaultLanguage = options.lang || hubLang || REFERENCE_LANG;
  var lang = (DEBUG_MODE ? queryLang || defaultLanguage : defaultLanguage).replace(/_/g, '-');
  return {
    lng: lang,
    fallbackLng: options.fallBackLang || REFERENCE_LANG,
    appendNamespaceToCIMode: true,
    // Using the feature to add new keys during development is meant to be only used during development.
    // Using it in production can lead to spamming Locize endpoint with unneeded requests.
    // Doing so can force us to start charging you for those saveMissing calls (which currently are free)
    // or in worst case we will be forced to suspend your account.
    // More on https://docs.locize.com/guides-tips-and-tricks/going-production
    saveMissing: DEBUG_MODE,
    // have a common namespace used around the full app
    ns: options.ns || ['translations'],
    defaultNS: options.defaultNs || 'translations',
    debug: DEBUG_MODE,
    keySeparator: false,
    // we use content as keys, default is '.'
    nsSeparator: false,
    // we use content as keys, default is ':'
    load: 'currentOnly',
    backend: {
      projectId: locizeProjectId,
      apiKey: locizeApiKey,
      version: DEBUG_MODE ? DEV_VERSION : CACHABLE_VERSION,
      referenceLng: REFERENCE_LANG,
      allowedAddOrUpdateHosts: DEBUG_HOSTS
    },
    postProcess: [DEBUG_MODE ? 'languagePrefix' : null],
    react: {
      wait: true,
      bindStore: false
    },
    editor: {
      // trigger a reload on editor save
      onEditorSaved: function onEditorSaved() {
        location.reload();
      }
    }
  };
};

var i18nLocize = function i18nLocize(locizeProjectId, locizeApiKey, options) {
  _i18next.default.use(_i18nextLocizeBackend.default).use(_locizeEditor.default).use(new _languagePrefix.default()).use(_reactI18next.reactI18nextModule).init(initOptions(locizeProjectId, locizeApiKey, options));

  return _i18next.default;
};

var _default = i18nLocize;
exports.default = _default;

var i18nLocizeInstance = function i18nLocizeInstance(locizeProjectId, locizeApiKey, options) {
  var i18nextInstance = _i18next.default.createInstance();

  i18nextInstance.use(_i18nextLocizeBackend.default).use(_locizeEditor.default).use(new _languagePrefix.default()).use(_reactI18next.reactI18nextModule).init(initOptions(locizeProjectId, locizeApiKey, options));
  return i18nextInstance;
};

exports.i18nLocizeInstance = i18nLocizeInstance;